<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row 
                    no-gutters 
                    align="start" 
                    justify="space-between">
                    <v-col sm="auto">
                        <div class="title">
                            Externo | Mis Servicios
                        </div>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text class="mt-5">
                <v-row v-if="loading">
                    <v-col
                        v-for="i in [1, 2, 3, 4, 5, 6]"
                        :key="'sl_' + i"
                        cols="12"
                        md="2"
                        sm="3"
                        xs="6"
                    >
                        <v-skeleton-loader
                            ref="skeleton"
                            :tile="true"
                            type="image"
                            class="mx-auto"
                        />
                    </v-col>
                </v-row>
                <v-row v-else-if="servicios.length > 0">
                    <v-col
                        v-for="i in servicios"
                        :key="'sl_serv_' + i.idServicio"
                        cols="12"
                        md="2"
                        sm="3"
                        xs="6"
                    >
                        <icono-servicio :servicio="i"/>
                    </v-col>
                </v-row>
                <v-row v-else>
                    <v-col 
                        cols="12" 
                        md="12" 
                        xs="12">
                        <v-alert type="info">
                            No hay servicios disponibles.
                        </v-alert>
                    </v-col>
                </v-row>
                <br >
                <expansion-panels-servicios-disponibles/>
            </v-card-text>
        </v-card>
        <v-snackbar
            key="snackbar_serviciosexterno"
            v-model="snackbarError"
            :bottom="true"
            :multi-line="true"
            color="error"
        >
            {{ textoError }}
            <v-btn 
                dark 
                text 
                @click="snackbarError = false">
                Cerrar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { getServiciosExterno } from "@/api";

export default {
  name: "ServiciosExterno",
  components: {
    IconoServicio: () => import("../../components/atoms/IconoServicio"),
    ExpansionPanelsServiciosDisponibles: () =>
      import("../../components/organisms/ExpansionPanelsServiciosDisponibles")
  },
  props: {},
  data () {
    return {
      servicios: [],
      loading: true,
      snackbarError: false,
      textoError: ""
    };
  },
  computed: {},
  mounted () {
    this.getServiciosExterno_();
  },
  methods: {
    async getServiciosExterno_ () {
      var self = this;
      self.loading = true;
      try {
        let response = await getServiciosExterno();

        if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "True") {
              self.servicios = response.data.data;
              self.snackbarError = false;
              self.textoError = "";
            }
          } else {
            self.snackbarError = true;
            self.textoError = response.data.message;
          }
        } else {
          self.snackbarError = true;
          self.textoError = "Error de red";
        }

        self.loading = false;
      } catch (e) {
        self.loading = false;

        self.snackbarError = true;
        self.textoError = e;
      }
    },
    goUrlServicio (url) {
      window.location.href = url;
    }
  }
};
</script>
